import { createRouter, createWebHistory } from "vue-router";
import { getRoutes } from "./routes";
import { checkAuthorization } from "./authorization";
import store from "../store.js";
import Clarity from "@microsoft/clarity";
import { CLARITY_ENABLED } from "@/config/index.js";
import i18n from "@/lib/i18n";
import { trackHistoryPopNavigations } from "@/lib/listFiltersMemory";

// The new UI swaps views out-in (the old view leaves in 120 ms), so a saved position waits for the new view.
const restoreAfterViewTransition = (savedPosition) => {
  if (!savedPosition || !document.body.classList.contains("new-ui")) {
    return savedPosition;
  }

  return new Promise((resolve) => {
    setTimeout(() => resolve(savedPosition), 160);
  });
};

const router = createRouter({
  linkActiveClass: "open active",
  scrollBehavior: (to, from, savedPosition) => {
    if (to.name !== undefined) {
      if (to?.name === "calendar.presences.child" || to?.name?.includes("transactions.parent")) {
        return restoreAfterViewTransition(savedPosition);
      } else if (to?.name === "calendar.subjects" && from?.name === "calendar.presences.child") {
        return restoreAfterViewTransition(savedPosition);
      } else if (
        to?.name?.includes("transactions") &&
        from?.name?.includes("transactions.parent")
      ) {
        return restoreAfterViewTransition(savedPosition);
      }
    }

    return { top: 0 };
  },
  history: createWebHistory(),
  routes: getRoutes(),
});

trackHistoryPopNavigations(router);

checkAuthorization(router);

router.afterEach((to) => {
  if (CLARITY_ENABLED && typeof to.meta.clarityUpgradeReason === "string") {
    Clarity.upgrade(to.meta.clarityUpgradeReason);
  }
});

router.beforeEach((to, from, next) => {
  const hasUnsavedChanges = store.getters["hasUnsavedChanges"];

  if (!hasUnsavedChanges) {
    next();

    return;
  }

  if (
    confirm(
      i18n.global.t(
        "You have some unsaved changes. Are you sure you want to leave this page without saving changes?",
      ),
    )
  ) {
    store.dispatch("setHasUnsavedChanges", false);

    next();
  } else {
    next(false);
  }
});

export default router;
